export const CODEARTIFACT_PACKAGE_ANNOTATION = 'ssm.io/codeartifact-package';

export interface VersionInfo {
  version: string;
  status: string;
  publishedTime?: string;
}

export interface PackageVersions {
  package: string;
  latest: string | null;
  versions: VersionInfo[];
}

/** Calls the backend plugin with the credentials of the signed-in user. */
export async function fetchVersions(
  baseUrl: string,
  fetchApi: { fetch: typeof fetch },
  name: string,
): Promise<PackageVersions> {
  const response = await fetchApi.fetch(`${baseUrl}/versions?package=${encodeURIComponent(name)}`);
  if (!response.ok) {
    throw new Error(
      response.status === 404
        ? `${name} has no published versions in CodeArtifact yet`
        : `CodeArtifact request failed: ${response.status} ${response.statusText}`,
    );
  }
  return (await response.json()) as PackageVersions;
}
